﻿import VeilederIasDto from '../Models/VeilederIasDto';
import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';

const beggeNyEktefelleSamboer = 'b1-jaBegge';
const enNyEktefelleSamboer = 'b2-jaEn';
const ingenNyEktefelleSamboer = 'b3-neiIngen';
const aleneforelderNyEktefelleSamboer = 'b4-nyEktefelleSamboer';
const aleneforelderIkkeNyEktefelleSamboer = 'b5-ikkeNyEktefelleSamboer';

const bValg: RadioButtonValgModel<VeilederIasDto>[] = [
    { id: 'b1', value: beggeNyEktefelleSamboer, tekst: 'valgSivilstatusBegge' },
    { id: 'b2', value: enNyEktefelleSamboer, tekst: 'valgSivilstatusEn' },
    { id: 'b3', value: ingenNyEktefelleSamboer, tekst: 'valgSivilstatusIngen' },
];

const bxValg: RadioButtonValgModel<VeilederIasDto>[] = [
    { id: 'b4', value: aleneforelderNyEktefelleSamboer, tekst: 'valgEnForelderJa' },
    { id: 'b5', value: aleneforelderIkkeNyEktefelleSamboer, tekst: 'valgEnForelderNei' },
];

export default {
    b1_sivilstatusBegge: beggeNyEktefelleSamboer,
    b2_sivilstatusEn: enNyEktefelleSamboer,
    b3_sivilstatusIngen: ingenNyEktefelleSamboer,
    b4_valgEnForelderJa: aleneforelderNyEktefelleSamboer,
    b5_valgEnForelderNei: aleneforelderIkkeNyEktefelleSamboer,
    bValg,
    bxValg,
};
